<template>
    <div>
        <h-table
            :data="data"
            row-key="label"
            :columns="columns"
            :filter="filter"
            :visible-columns="visibleColumns"
            :pagination.sync="serverPagination"
            :rows-per-page-options="perPageOptions"
            :loading="loading"
            ref="table"
            @request="fetchData"
        >
            <q-td
                slot="body-cell-is_default"
                slot-scope="props"
            >
                <q-checkbox
                    :value="props.value"
                    @input="makeProviderDefault(props.row)"
                />
            </q-td>
            <q-td
                slot="body-cell-enabled"
                slot-scope="props"
            >
                <q-toggle
                    :value="props.value"
                    @input="val => val ? activateProvider(props.row) : deactivateProvider(props.row)"
                    color="positive"
                />
            </q-td>
            <q-td
                slot="body-cell-edit"
                class="text-right"
                slot-scope="props"
            >
                <q-btn
                    @click="showPaymentSettings(props.value)"
                    icon="settings"
                    color="tertiary"
                    class="hover-positive"
                    flat
                    round
                />
                <q-btn
                    @click="editProvider(props.value)"
                    icon="edit"
                    color="tertiary"
                    class="hover-primary"
                    flat
                    round
                />
                <q-btn
                    @click="deleteProvider(props.value)"
                    icon="delete"
                    color="tertiary"
                    class="hover-negative"
                    flat
                    round
                />
            </q-td>
        </h-table>
        <payment-method-edit
            v-model="paymentSettingsOpened"
            :paymentDetails.sync="paymentDetails"
            :provider="provider"
        />
        <service-provider-edit
            v-model="editProviderOpened"
            :provider="provider"
            @save="updateProviders()"
        />
    </div>
</template>

<script>
import _ from 'lodash'

import { HTable, HTh } from '@'

import tableHelpers from '@/HTable/helpers'
import api from 'mixins/api'
import columns from './mixins/columns'

import ServiceProviderEdit from '@/ServiceProviderEdit'
import PaymentMethodEdit from '@/PaymentMethodEdit'

import {
    QBtn,
    QBtnToggle,
    QCheckbox,
    QField,
    QIcon,
    QInput,
    QPopover,
    QTable,
    QTableColumns,
    QTd,
    QTh,
    QToggle,
    QTooltip,
    QTr,
} from 'quasar'

export default {
    name: 'ServiceProviders',
    components: {
        QTable,
        QTableColumns,
        QTr,
        QTh,
        QTd,
        QField,
        QInput,
        QCheckbox,
        QBtn,
        QBtnToggle,
        QIcon,
        QTooltip,
        QPopover,
        HTable,
        HTh,
        QToggle,
        ServiceProviderEdit,
        PaymentMethodEdit,
    },
    mixins: [
        tableHelpers,
        api,
        columns,
    ],
    data () {
        return {
            visibleColumns: this.getVisibleColumns() || ['name', 'alias', 'enabled', 'edit', 'is_default'],
            editProviderOpened: false,
            paymentSettingsOpened: false,
            provider: {
                name: '',
                vat_rate: '',
            },
            paymentDetails: [],
        }
    },
    mounted () {
        this.fetchData({
            pagination: this.serverPagination,
            filter: this.filter,
        })
    },
    methods: {
        fetchData ({ pagination, filter }) {
            this.query = this.getQuery(pagination, filter)
            this.loading = true
            this.api.get(`service-providers/${this.query}`).then(response => {
                if (this.verifyResponse(response)) {
                    this.updatePagination(pagination, response.data.total)
                    this.updateData(response.data)
                }
                this.loading = false
            }).catch(error => {
                console.error(error)
                this.loading = false
            })
        },
        updateProviders () {
            this.fetchData({
                pagination: this.serverPagination,
                filter: this.filter,
            })
        },
        showPaymentSettings (id) {
            this.paymentSettingsOpened = true
            this.paymentDetails = this.data.find(row => row.id === id).payment_details
            Object.assign(this.provider, this.data.find(row => row.id === id))
        },
        editProvider (id) {
            this.editProviderOpened = true
            Object.assign(this.provider, this.data.find(row => row.id === id))
        },
        addProvider () {
            this.editProviderOpened = true
            this.clearDataObject(this.provider)
        },
        deleteProvider (id) {
            Object.assign(this.provider, this.data.find(row => row.id === id))

            this.$q.dialog({
                title: 'Удаление',
                message: 'Вы действительно хотите удалить данного поставщика услуг?',

                // optional
                color: 'primary',

                // optional; we want an "OK" button
                ok: true, // takes i18n value, or String for "OK" button label

                // optional; we want a "Cancel" button
                cancel: true, // takes i18n value, or String for "Cancel" button label

                // optional; a position of the Dialog (top, bottom, left, right)
                //position: 'top',
            }).then(() => {
                // Picked "OK"
                this.$http.delete(`/api/v1.0/service-providers/${this.provider.id}`, this.provider).then(response => {
                    this.$q.notify({
                        message: 'Удалено',
                        type: 'positive',
                    })
                    this.fetchData({
                        pagination: this.serverPagination,
                        filter: this.filter,
                    })
                }).catch(error => {

                })
            }).catch(() => {
                // Picked "Cancel" or dismissed
            })

        },
        /*saveProvider () {
          this.$v.provider.$touch();
          if (this.$v.provider.$error) {
            this.$q.notify('Please review fields again.');
            return;
          }
          if (this.provider.id) {
            this.$http.put(`/api/v1.0/service-providers/${this.provider.id}`, this.provider).then(response => {
              this.editProviderOpened = false;
              this.$q.notify({
                message: 'Сохранено',
                type: 'positive'
              });
              this.fetchData({
                pagination: this.serverPagination,
                filter: this.filter
              });
            }).catch(error => {
              _.forIn(error.response.data.errors, (value, key) => {
                this.$q.notify({message: value[0], type: 'negative'});
              });
            });

          } else {
            this.$http.post(`/api/v1.0/service-providers`, this.provider).then(response => {
              this.editProviderOpened = false;
              this.$q.notify({
                message: 'Сохранено',
                type: 'positive'
              });
              this.fetchData({
                pagination: this.serverPagination,
                filter: this.filter
              });
            }).catch(error => {
              _.forOwn(error.response.data.errors, (value, key) => {
                this.$q.notify({message: value[0], type: 'negative'});
              });
            });
          }
        },*/
        clearDataObject (object) {
            _.forOwn(object, (value, key) => {
                switch (value.constructor) {
                    case Boolean:
                        object[key] = false
                        break
                    case String:
                        object[key] = ''
                        break
                    case Number:
                        object[key] = null
                        break
                    case Array:
                        object[key] = {}
                        break
                    case Object:
                        object[key] = []
                        break
                }
            })
        },
        /*uploadFile (file, updateProgress) {
          let formData = new FormData(),
            config = {
              onUploadProgress: function (progressEvent) {
                updateProgress(progressEvent.loaded / progressEvent.total);
              }
            };

          formData.append('image', file);
          return new Promise((resolve, reject) => {
            this.$http.post('/api/v1.0/media/service-providers/', formData, config).then(response => {
              this.provider.stamp_img_url = new URL(response.data.data.path).pathname;
              resolve(file);
            }).catch(error => {
              reject(error);
              console.error(error);
            });
          });
        },*/
        activateProvider (provider) {
            if (provider.enabled) {
                return
            }
            this.$q.dialog({
                title: 'Включить реквизиты?',
                message: 'Сделать доступными для выбора',
                ok: 'Да',
                cancel: 'Нет',
            }).then(() => {
                provider.enabled = true
                this.$http.post(`/api/v1.0/service-providers/${provider.id}/enable`).then(response => {
                    this.$q.notify({ message: 'Сохранено', type: 'positive' })
                }).catch(error => {
                    this.fetchData({
                        pagination: this.serverPagination,
                        filter: this.filter,
                    })
                    if (error.response.data.message) {
                        this.$q.notify({ message: error.response.data.message, type: 'negative' })
                    }
                    if (error.response.data.errors) {
                        _.forIn(error.response.data.errors, (value, key) => {
                            this.$q.notify({ message: value[0], type: 'negative' })
                        })
                    }
                })
            })
        },
        deactivateProvider (provider) {
            if (!provider.enabled) {
                return
            }
            this.$q.dialog({
                title: 'Отключить поставщика?',
                message: 'Сделать недоступными для выбора',
                ok: 'Да',
                cancel: 'Нет',
            }).then(() => {
                provider.enabled = false
                this.$http.post(`/api/v1.0/service-providers/${provider.id}/disable`).then(response => {
                    this.$q.notify({ message: 'Сохранено', type: 'positive' })
                }).catch(error => {
                    provider.enabled = true
                    if (error.response.data.message) {
                        this.$q.notify({ message: error.response.data.message, type: 'negative' })
                    }
                    if (error.response.data.errors) {
                        _.forIn(error.response.data.errors, (value, key) => {
                            this.$q.notify({ message: value[0], type: 'negative' })
                        })
                    }
                })
            })
        },
        makeProviderDefault (provider) {
            if (provider.is_default) {
                return
            }
            this.$q.dialog({
                title: 'Сдеалать поставщика выбраным по умолчанию?',
                message: 'Только один поставщик в регионе может быть выбраным по умолчанию',
                ok: 'Да',
                cancel: 'Нет',
            }).then(() => {
                let defaultProvider = this.data.find(row => row.is_default && provider.region === row.region)
                defaultProvider.is_default = false
                provider.is_default = true

                this.$http.post(`/api/v1.0/service-providers/${provider.id}/as-default`).then(response => {
                  this.$q.notify({message: 'Сохранено', type: 'positive'})
                }).catch(error => {
                    provider.is_default = false
                    defaultProvider.is_default = true
                    if (error.response.data.message) {
                        this.$q.notify({message: error.response.data.message, type: 'negative'})
                    }
                    if (error.response.data.errors) {
                        _.forIn(error.response.data.errors, (value, key) => {
                            this.$q.notify({message: value[0], type: 'negative'})
                        })
                    }
                })
          })
      },
    },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ServiceProviders/ServiceProviders.vue